import React, { useState } from "react";
import ResponsiveAppBar from "./AppBar";
import { styled, useTheme } from "@mui/material/styles";
import {
  Drawer as MuiDrawer,
  List,
  Divider,
  ListItemButton,
  Collapse
} from "@mui/material";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import "./styles.scss";
import { NavLink } from "react-router-dom";
import { dateFormat } from "../../utils/date";
import { useDispatch, useSelector } from "react-redux";
import { getUserMenuItem_action } from "../../Redux/User/action";
import { getItem } from "../../utils/crypto";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import Modal from "@mui/material/Modal";

//Sadanand Gadwal - Manual Icon For Dashboard
const ORMIcon = React.lazy(() => import("@mui/icons-material/Groups3"));
const DashboardIcon = React.lazy(() => import("@mui/icons-material/Home"));
const CivilIcon = React.lazy(() => import("@mui/icons-material/Engineering"));
const LiaisonIcon = React.lazy(() => import("@mui/icons-material/Policy"));
const BDIcon = React.lazy(() => import("@mui/icons-material/LocationCity"));
const LegalIcon = React.lazy(() => import("@mui/icons-material/Gavel"));
const AdminIcon = React.lazy(
  () => import("@mui/icons-material/AdminPanelSettings")
);
const TrainingIcon = React.lazy(
  () => import("@mui/icons-material/ModelTraining")
);
const AccountIcon = React.lazy(
  () => import("@mui/icons-material/ManageAccounts")
);
const ReportIcon = React.lazy(() => import("@mui/icons-material/Summarize"));
const menuIcon = React.lazy(
  () => import("@mui/icons-material/AlignHorizontalLeft")
);
const ProcurementIcon = React.lazy(
  () => import("@mui/icons-material/ReceiptLong")
);

//Icons Delcare
const IconObject = {
  ORM: ORMIcon,
  Dashboard: DashboardIcon,
  Civil: CivilIcon,
  Liaison: LiaisonIcon,
  BD: BDIcon,
  Admin: AdminIcon,
  Common: CivilIcon,
  Legal: LegalIcon,
  Training: TrainingIcon,
  Accounts: AccountIcon,
  Report: ReportIcon,
  Master: menuIcon,
  Report: ReportIcon,
  Procurement: ProcurementIcon
};

const returnIcon = (key) => {
  if (IconObject.hasOwnProperty(key)) {
    return IconObject[key];
  } else {
    return IconObject["Common"];
  }
};

const CollpseComponent = ({
  item,
  setSidebar,
  isSidebar,
  openParentMenu,
  setOpenParentMenu,
  openSubMenu,
  setOpenSubMenu
}) => {
  const handleMenuClick = (menuId) => {
    setOpenParentMenu((prevState) => ({
      ...prevState,
      [menuId]: !prevState[menuId]
    }));
    if (!isSidebar) {
      setSidebar(true);
    }
  };

  const handleSubMenuClick = (subMenuId) => {
    setOpenSubMenu((prevState) => ({
      ...prevState,
      [subMenuId]: !prevState[subMenuId]
    }));
    if (!isSidebar) {
      setSidebar(true);
    }
  };

  const handleNavLink = (route) => {
    if (!isSidebar) {
      setSidebar(true);
    }
  };

  const ReactIcon = returnIcon(item?.menu_name);
  const subTextRefs = React.useRef({});

  React.useEffect(() => {
    const subtextElements = document.querySelectorAll(
      ".subtext, .subtext_direct_link"
    );

    subtextElements.forEach((element) => {
      if (isEllipsisActive(element)) {
        const menuId = element.getAttribute("data-menu-id");
        subTextRefs.current[menuId] = element;
        addTooltip(element);
      }
    });
  });

  function isEllipsisActive(element) {
    return element.offsetWidth < element.scrollWidth;
  }

  function addTooltip(element) {
    element.setAttribute("data-tooltip-content", element.textContent.trim());
  }

  return (
    <>
      <ListItemButton
        key={item?.menu_id}
        onClick={() => handleMenuClick(item?.menu_id)}
        className="d-flex justify-content-between align-items-center menuItemDivMain"
      >
        <div className="d-flex justify-content-between">
          <div className="d-flex">
            <React.Suspense fallback={<div>..</div>}>
              <ReactIcon />
            </React.Suspense>
            <div className="navbar-text">{item?.menu_name} </div>
          </div>
        </div>
        <div>
          {openParentMenu[item?.menu_id] ? <ExpandLess /> : <ExpandMore />}
        </div>
      </ListItemButton>
      {/* Sadanand Gadwal - Menu Logic rewritten  */}
      {item?.menu_link?.length > 0 &&
        item?.menu_link?.map((menu) => {
          if (menu?.isSubMenu === 1) {
            return (
              <Collapse
                key={menu?.itemID}
                in={openParentMenu[item?.menu_id]}
                timeout="auto"
                unmountOnExit
              >
                <List component="div" disablePadding>
                  <ListItemButton
                    onClick={() => handleSubMenuClick(menu?.itemID)}
                    className="d-flex justify-content-between align-items-center menuItemDivCollapse"
                  >
                    <div className="d-flex justify-content-between sub-item-collapse">
                      <div className="d-flex">
                        <div
                          className={
                            openSubMenu[menu?.itemID]
                              ? "sub-navbar-text-bold"
                              : "sub-navbar-text"
                          }
                        >
                          {menu?.itemName}
                        </div>
                      </div>
                    </div>
                    <div>
                      {openSubMenu[menu?.itemID] ? (
                        <RemoveIcon sx={{ width: "20px", height: "20px" }} />
                      ) : (
                        <AddIcon sx={{ width: "20px", height: "20px" }} />
                      )}
                    </div>
                  </ListItemButton>

                  {menu?.subItem?.map((subItem) => (
                    <Collapse
                      key={subItem.itemID}
                      in={openSubMenu[menu?.itemID]}
                      timeout="auto"
                      unmountOnExit
                      className="sub-item-collapse-tree"
                    >
                      <List component="div" disablePadding>
                        <NavLink
                          to={subItem.routingPath}
                          target={subItem.newTab ? "_blank" : ""}
                        >
                          {({ isActive }) => (
                            <span className={isActive ? "activeMenu" : ""}>
                              <ListItemButton
                                sx={{ pl: 0 }}
                                onClick={() =>
                                  handleNavLink(subItem.routingPath)
                                }
                                className={
                                  isActive ? "activeMenu" : "menuItemDiv"
                                }
                              >
                                <div className="horizontal-line"></div>
                                <div
                                  className="subtext"
                                  data-menu-id={subItem.itemID}
                                  data-tooltip-id="my-tooltip"
                                >
                                  <span style={{ fontSize: "4px" }}>
                                    &#9898; &nbsp; &nbsp; &nbsp; &nbsp;
                                  </span>
                                  {subItem.itemName}
                                </div>
                              </ListItemButton>
                            </span>
                          )}
                        </NavLink>
                      </List>
                    </Collapse>
                  ))}
                </List>
              </Collapse>
            );
          }
          return (
            <Collapse
              key={menu?.itemID}
              in={openParentMenu[item?.menu_id]}
              timeout="auto"
              unmountOnExit
              className="sub-item-collapse-link"
            >
              <List component="div" disablePadding>
                <NavLink
                  to={menu?.routingPath}
                  target={menu?.newTab ? "_blank" : ""}
                >
                  {({ isActive }) => (
                    <span className={isActive ? "activeMenu" : ""}>
                      <ListItemButton
                        sx={{ pl: 0 }}
                        onClick={() => handleNavLink(menu?.routingPath)}
                        className={isActive ? "activeMenu" : "menuItemDiv"}
                      >
                        <div className="horizontal-line"></div>
                        <div
                          className="subtext_direct_link"
                          data-menu-id={menu?.itemID}
                          data-tooltip-id="my-tooltip"
                        >
                          {menu?.itemName}
                        </div>
                      </ListItemButton>
                    </span>
                  )}
                </NavLink>
              </List>
            </Collapse>
          );
        })}
    </>
  );
};

const drawerWidth = 210;

const openedMixin = (theme) => ({
  width: drawerWidth,
  top: "auto",
  background: "#1d213e !important",
  color: "#fff !important",
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen
  }),
  overflowX: "hidden"
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen
  }),
  overflowX: "hidden",
  top: "auto",
  background: "#1d213e !important",
  color: "#fff !important",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(7)} + 1px)`
  }
});

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open"
})(({ theme, open }) => ({
  width: drawerWidth,
  height: "90vh",
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme)
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme)
  })
}));

const userLocal = getItem("enuseloc");
const LoginuserId =
  userLocal && Object.keys(userLocal).length > 0 ? userLocal["user_id"] : null;

function Navbar(props) {
  const [openParentMenu, setOpenParentMenu] = useState({});
  const [openSubMenu, setOpenSubMenu] = useState({});

  const dispatch = useDispatch();

  const getUserMenuItemList = useSelector(
    (state) => state.user.getUserMenuItemList
  );

  const [menu, setMenu] = React.useState([]);

  React.useEffect(() => {
    const payload = {
      userID: LoginuserId
    };
    dispatch(getUserMenuItem_action(payload));

    return () => {
      setMenu([]);
    };
  }, []);

  React.useEffect(() => {
    if (getUserMenuItemList && getUserMenuItemList.length > 0) {
      setMenu(getUserMenuItemList);
    }
  }, [getUserMenuItemList]);

  const [isSidebar, setSidebar] = useState(true);
  const theme = useTheme();

  const ontoggleClick = () => {
    setSidebar(!isSidebar);
    setOpenParentMenu({});
  };

  const handleDrawerClose = () => {
    setSidebar(!isSidebar);
    setOpenParentMenu({});
  };

  const isMobile = window.innerWidth <= 768;

  return (
    <div className="navbar">
      <div className="header">
        <ResponsiveAppBar
          ontoggleClick={ontoggleClick}
          isSidebar={isSidebar}
          handleDrawerClose={handleDrawerClose}
        />
      </div>
      <div className="main-body">
        <div className="sidebar">
          {isMobile ? (
            <Modal open={isSidebar} onClose={() => setSidebar(false)}>
              <div
                className="modal-sidebar mobile-modal"
                style={{
                  width: "250px",
                  height: "100%",
                  background: "#1D213E",
                  color: "#ffffff",
                  position: "fixed",
                  left: 0,
                  top: 50,
                  transform: isSidebar ? "translateX(0)" : "translateX(-100%)",
                  transition: "transform 0.3s ease",
                  // boxShadow: "2px 0 8px rgba(0,0,0,0.2)",
                  overflowY: "auto"
                }}
              >
                <List>
                  {menu?.map((_menu, index) => (
                    <React.Fragment key={index}>
                      <CollpseComponent
                        item={_menu}
                        setSidebar={setSidebar}
                        isSidebar={isSidebar}
                        openParentMenu={openParentMenu}
                        setOpenParentMenu={setOpenParentMenu}
                        openSubMenu={openSubMenu}
                        setOpenSubMenu={setOpenSubMenu}
                      />
                    </React.Fragment>
                  ))}
                </List>
                <Divider />
              </div>
            </Modal>
          ) : (
            <Drawer variant="permanent" open={isSidebar}>
              <List>
                {menu?.map((_menu, index) => (
                  <React.Fragment key={index}>
                    <CollpseComponent
                      item={_menu}
                      setSidebar={setSidebar}
                      isSidebar={isSidebar}
                      openParentMenu={openParentMenu}
                      setOpenParentMenu={setOpenParentMenu}
                      openSubMenu={openSubMenu}
                      setOpenSubMenu={setOpenSubMenu}
                    />
                  </React.Fragment>
                ))}
              </List>
              <Divider />
            </Drawer>
          )}
        </div>

        <div className="content">
          <div>{props.children}</div>
        </div>
      </div>
    </div>
  );
}

export default Navbar;
